const lineHeightComputed = '1rem';
const lineHeightBase = '1.25';
const fontSizeBase = '1rem';
const fontSizeSmall = '0.875rem';
const fontSizeSmaller = '.75rem';
const fontSizeSmallest = '.35rem';
const fontSizeXS = '.575rem';
const fontSizeLarge = '1.25rem';
const fontSizeLarger = '1.5rem';
const fontSizeXL = '1.75rem';
const fontSizeXXL = '2.75rem';
const fontSizeMD = '0.95rem';

const headingsFontWeight = '500';
const btnFontWeight = '600';
const talkerFontWeight = '400';
const toolbarButtonFontSize = '1.75rem';
const modalTitleFw = '400';

export {
  lineHeightComputed,
  lineHeightBase,
  fontSizeBase,
  fontSizeSmall,
  fontSizeSmaller,
  fontSizeSmallest,
  fontSizeXS,
  fontSizeLarge,
  fontSizeLarger,
  fontSizeXL,
  fontSizeXXL,
  fontSizeMD,
  headingsFontWeight,
  btnFontWeight,
  talkerFontWeight,
  toolbarButtonFontSize,
  modalTitleFw,
};
